import type { Plurals } from 'types/labels'

export const getPluralTranslation = ({
	locale,
	plurals,
	count,
}: {
	locale: string
	plurals: Plurals
	count: number
}): string => {
	const pluralRules = new Intl.PluralRules(locale, {
		type: 'cardinal',
	})

	const pluralForm = pluralRules.select(count)

	return plurals[pluralForm] ?? Object.values(plurals)[0] ?? ''
}
